import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const ContentWrapper = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 5px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: auto;

    .event-log-content {
        display: flex;
        flex-direction: column;
        gap: 16px;

        ul {
            margin: 10px 0 8px;
        }
    }
`;

export const NormalText = styled.div`
    color: #33373A;
    font-feature-settings: 'liga' off, 'clig' off;
    /* action task */
    font-family: "Noto Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const TimestampText = styled.div`
    color: #9A9A9A;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Time & Date Task Log */
    font-family: "Noto Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;